import React from "react";

const containerStyle = {
  width: 50,
  textAlign: "center",
  padding: "0px 10px",
  height: 30,
  overflow: "hidden",
  whiteSpace: "nowrap",
  flex: 1,
  maxWidth: 50
};

const ToggleHideOption = ({ hidden, onClick, readOnly }) => (
  <div style={{ ...containerStyle }}>
    <a
      className="hide-option"
      style={{
        fontSize: 12,
        position: "relative",
        top: 2,
        color: "grey",
        cursor: readOnly ? "default" : "pointer",
        flex: 1
      }}
      href="javascript:;"
      onClick={readOnly ? null : onClick}
    >
      {hidden ? readOnly ? "" : "unhide" : readOnly ? "" : "hide"}
    </a>
  </div>
);

ToggleHideOption.style = containerStyle;

export default ToggleHideOption;
